var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToastWarn = function SvgIconToastWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FFF9E9",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8A700",
    fillRule: "evenodd",
    d: "M17.75 9.17a1.75 1.75 0 1 0-3.5 0v8.669a1.75 1.75 0 1 0 3.5 0zM16 24.58a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconToastWarn;